<app-card class="density-lower">
    <form [formGroup]="form" class="density-mat-form-3" (keydown.enter)="$event.preventDefault(); onSearch()">
      <span class="estricta uppercase"> Filtros </span>
      <br /><br />

      <div class="filters">
        <div class="group1">
          <span class="form-field">
            <label> Tipo de Comissão: </label>
            <mat-form-field appearance="outline" class="density-mat-form-3">
              <mat-select formControlName="commissionType" data-cy="commission-type" placeholder="Selecione o tipo" (selectionChange)="updateLabelsAndFields()">
                <mat-option *ngFor="let type of commissionTypes" [value]="type.id">{{ type.description }}</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>

        <div class="group1">
          <span class="form-field">
            <label> Ponto de Venda: </label>
            <mat-form-field appearance="outline" class="density-mat-form-3">
              <mat-select formControlName="identifierCode" data-cy="dealer" placeholder="Selecione">
                <mat-option *ngFor="let dealerOption of dealerOptions" [value]="dealerOption.value"> {{dealerOption.key}}
                </mat-option>
              </mat-select>

              <mat-error *ngIf="form.get('identifierCode').hasError('required') && form.get('identifierCode').touched" data-cy="dealerRequiredError">
                <strong> Campo obrigatório </strong>
              </mat-error>
            </mat-form-field>
          </span>
        </div>
      </div>

      <div *ngIf="startDateLabel || endDateLabel" class="filters">
        <div class="group1">
          <app-custom-datapicker [label]="startDateLabel" formControlName="startDate" [control]="form.get('startDate')"
            datacy="startSalesDate">
            @if (form.hasError('startGreaterThanEnd')) {
              <mat-error class="fix-error-position" data-cy="startSalesDateErrorStartGreaterThanEnd">
                <strong> Data Inicial não pode ser maior que data final </strong>
              </mat-error>
            } @else if (form.hasError('startDate-required') && (form.get('endDate').touched || form.get('startDate').touched)) {
              <mat-error class="fix-error-position" data-cy="startSalesDateErrorRequired">
                <strong> Data inicial deve ser prenchida </strong>
              </mat-error>
            } @else if (form.hasError('periodGreaterThan')) {
              <mat-error class="fix-error-position" data-cy="startSalesDateErrorPeriodGreaterThan30Days">
                <strong> Não é possível efetuar pesquisa com mais de 30 dias  </strong>
              </mat-error>
            }
          </app-custom-datapicker>
        </div>
        <div class="group1">
          <app-custom-datapicker [label]="endDateLabel" formControlName="endDate" [control]="form.get('endDate')"
            datacy="endSalesDate">
            <mat-error *ngIf="form.hasError('endDate-required') && (form.get('endDate').touched || form.get('startDate').touched)" class="fix-error-position" data-cy="endSalesDateErrorRequired">
              <strong> Data final deve ser prenchida </strong>
            </mat-error>
          </app-custom-datapicker>
        </div>
      </div>

      <div class="filters">

        <div *ngFor="let filter of comissionType?.filters">
          <div class="group1">
            <span class="form-field">
              <label> {{filter.description}} </label>
              <mat-form-field appearance="outline" class="density-mat-form-3">
                <mat-select [formControlName]="filter.key" [attr.data-cy]="'filter-by-' + filter.key" placeholder="Selecione">
                  <mat-option *ngFor="let filterOption of filter.options" [value]="filterOption.key"> {{filterOption.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </div>
        </div>


        <div *ngIf="showSearchInput" class="group1">
          <span class="form-field">
            <label> Buscar: </label>
            <mat-form-field appearance="outline">
                <input type="text"
                       formControlName="searchTerm"
                       maxLength="100"
                       data-cy="search-term"
                       placeholder="Digite"
                       (input)="enforceInteger($event)"
                       matInput>

                       <mat-error *ngIf="form.get('searchTerm').hasError('maxLength')" data-cy="search-term-max-length-error">
                        <strong> Campo deve ter no máximo 9 caracteres </strong>
                      </mat-error>
            </mat-form-field>
          </span>
        </div>
      </div>

      <div class="button-filters">
        <app-button
          type="button"
          width="100%"
          (onClick)="cleanForm()"
          datacy="button-clean">
          <span style="font-size: 16px;"> Limpar </span>
        </app-button>

        <app-button
          type="submit"
          width="100%"
          color="primary"
          [disabled]="!form.valid || loading"
          [loading]="loading"
          (onClick)="onSearch()"
          datacy="button-search">
          <span style="font-size: 16px;"> Pesquisar </span>
        </app-button>
      </div>
    </form>
  </app-card>
